import client from "./client";

const getBalance = () => client.post("/getCoin", {type: 0});

const requestPlatformConfig = (data?: {promoCode: string; inviteCode: string}) => client.post("/getPlatformConfig", data || {});

const ghostLogin = () => client.post("/ghostLogin");

const login = (type: "email" | "mobile", content: string, password: string, twoFaCode?: number) =>
    client.post("/login", {
        type: type === "email" ? 1 : 2,
        email: type === "email" ? content : "",
        mobile: type === "mobile" ? content : "",
        password,
        twoFaCode,
    });

const modifyUserPassword = (code: string, password: string) => client.post("/modifyUserPassword", {type: 1, code, password});

const register = (email: string, password: string, inviteCode?: string) =>
    client.post("/register", {
        type: 1,
        email,
        password,
        inviteCode: inviteCode || "-1",
        langId: 2,
    });

const getVerificationCodeSms = (countryCode: number, phoneNo: string, source?: number) =>
    client.post("/getVerificationCodeSms", {countryCode, phoneNo, source, langId: 2});

const getVerificationCode = (type: "email" | "mobile", account: string, purpose: string, userName?: string) =>
    client.post("/getVerificationCode", {
        type: type === "email" ? 1 : 2,
        account,
        userVo: {
            nick: userName,
        },
        purpose,
    });

const forgetPassword = (type: "email" | "mobile", account: string, code: string, password: string) =>
    client.post("/forgetPassword", {type: type === "email" ? "1" : "2", account, code, password});

const bindMobile = (code: number, phoneNo: string, userId?: number) =>
    client.post("/bindMobile", {
        code,
        phoneNo,
        userId,
    });

const userVerifyEmailByCode = (email: string, code: string) => client.post("/userVerifyEmailByCode", {email, code});

const userBindMobile = (account: string, code: string) => client.post("/userBindMobile", {type: 2, account, code});

const userSendVerifyEmail = (email: string) => client.post("/userSendVerifyEmail", {langId: 2, email});

const googleVerification = (userToken: string, code: string) => client.post("/googleVerification", {userToken, code});

const closeGoogleVerification = (code: string) => client.post("/closeGoogleVerification", {code});

const getGoogleVerificationQrCode = (userToken: string) => client.post("/getGoogleVerificationQrCode", {userToken});

const userSelfExclusion = (time: number) => client.post("/userSelfExclusion", {time});

const getUserOtherData = (token: string) => client.post("/getUserOtherData", {token});

const bindCPF = (account: string) =>
    client.post("/bindKycExtraData", {
        otherKycInfos: [
            {
                validateData: account,
                validateType: 0,
            },
        ],
        tokenId: 6,
    });

const getOtherUserData = (userId: number) => client.post("/getOtherUserData", {userId});

const modifyUserHead = (head: string) => client.post("/modifyUserHead/", {head});

const modifyUserName = (name: string) => client.post("/modifyUserName/", {name});

const taskGetList = () => client.post("/task/getList");

const taskRewardGet = (id: number) => client.post("/task/reward/get", {id});

// {firstName, lastName, gender, birth, address, zipCode, city, country}
const updateUserDetail = (data = {}) => client.post("/updateUserDetail", data);

const changeRewardRate = (data = {}) => client.post("/vip/changeRewardRate", data);

const getLoginHistory = (page: number, pageSize: number) =>
    client.post("/getLoginHistory", {
        pageId: page,
        pageCount: pageSize,
    });

const getUserByIdData = (ids: string[]) => {
    // /user/getBaseInfo
    client.post("/user/getBaseInfo", {
        userIds: ids,
    });
};

const apiUser = {
    login,
    register,
    getBalance,
    requestPlatformConfig,
    ghostLogin,
    getVerificationCodeSms,
    getVerificationCode,
    forgetPassword,
    bindMobile,
    userVerifyEmailByCode,
    userBindMobile,
    userSendVerifyEmail,
    googleVerification,
    closeGoogleVerification,
    getGoogleVerificationQrCode,
    userSelfExclusion,
    bindCPF,
    getOtherUserData,
    modifyUserHead,
    modifyUserName,
    getUserOtherData,
    taskGetList,
    taskRewardGet,
    updateUserDetail,
    changeRewardRate,
    getLoginHistory,
    getUserByIdData,
    modifyUserPassword
};

export default apiUser;
